export class TherapyTypeItem {
  constructor(public id: number, public displayName: string) {}
}
